/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getF64Decoder,
  getF64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export type Delegation = {
  voterPubkey: Address;
  stake: bigint;
  activationEpoch: bigint;
  deactivationEpoch: bigint;
  warmupCooldownRate: number;
};

export type DelegationArgs = {
  voterPubkey: Address;
  stake: number | bigint;
  activationEpoch: number | bigint;
  deactivationEpoch: number | bigint;
  warmupCooldownRate: number;
};

export function getDelegationEncoder(): Encoder<DelegationArgs> {
  return getStructEncoder([
    ['voterPubkey', getAddressEncoder()],
    ['stake', getU64Encoder()],
    ['activationEpoch', getU64Encoder()],
    ['deactivationEpoch', getU64Encoder()],
    ['warmupCooldownRate', getF64Encoder()],
  ]);
}

export function getDelegationDecoder(): Decoder<Delegation> {
  return getStructDecoder([
    ['voterPubkey', getAddressDecoder()],
    ['stake', getU64Decoder()],
    ['activationEpoch', getU64Decoder()],
    ['deactivationEpoch', getU64Decoder()],
    ['warmupCooldownRate', getF64Decoder()],
  ]);
}

export function getDelegationCodec(): Codec<DelegationArgs, Delegation> {
  return combineCodec(getDelegationEncoder(), getDelegationDecoder());
}
